import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>About Invex</h4>
            <p>
              Complete business management solution for restaurants, cafes, and retail stores in Saudi Arabia.
            </p>
            <p style={{ marginTop: '1rem' }}>
              Built by Invec
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/support">Support</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>

          <div className="footer-section">
            <h4>Features</h4>
            <p>Point of Sale (POS)</p>
            <p>Inventory Management</p>
            <p>Supplier Tracking</p>
            <p>Sales Analytics</p>
            <p>VAT Compliance</p>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: support@invexapp.com</p>
            <p>Location: Saudi Arabia</p>
            <p style={{ marginTop: '1rem' }}>
              Available on iOS & Android
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Invec. All rights reserved. | Invex - Complete Business Manager</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;